import Button from "../Button";
import "./index.css";
import UploadIcon from "../../Assests/Icons/UploadIcon";
import { useRef } from "react";

const FileUploader = ({handleFile, className}) => {
  const hiddenFileInput = useRef(null);

  const handleClick = () => {
    hiddenFileInput.current.click();
  };

  const handleChange = (event) => {
    const fileUploaded = event.target.files[0];
    handleFile(fileUploaded);
    hiddenFileInput.current.value = null;
  };
  return (
    <>
      <Button className={"flex items-center " + className} onClick={handleClick}>
      <UploadIcon />
       <span className="ml-1"> Upload</span>
      </Button>
      <input
        type="file"
        accept=".csv"
        ref={hiddenFileInput}
        onChange={handleChange}
        style={{ display: "none" }}
      />
    </>
  );
};
export default FileUploader;
